var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exception-page"},[_c('exception-page',{attrs:{"exception":_vm.exception}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }